import { SxProps, Theme } from '@mui/material/styles';

export const modalColors = {
    black3: '#1E2025',
    black4: '#252833',
    black5: '#2C2F3A',
    white: '#FFFFFF',
    white30: 'rgba(255, 255, 255, 0.3)',
    mainGold: '#FABB18',
    goldenYellow: '#FABB18',
    gold: '#C48E02',
    errorRed: '#EA1F1F'
};

export const dialogPaperStyles: SxProps<Theme> = {
    bgcolor: modalColors.black3,
    color: modalColors.white,
    height: '600px',
    display: 'flex',
    flexDirection: 'column'
};

export const dialogTitleStyles: SxProps<Theme> = {
    bgcolor: modalColors.black3,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: 2,
    m: 0
};

export const closeButtonStyles: SxProps<Theme> = {
    color: 'grey.400',
    p: 1,
    ml: 2,
    '&:hover': { color: 'white' }
};

export const dialogContentStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    p: 0
};

export const searchBoxStyles: SxProps<Theme> = {
    bgcolor: modalColors.black3,
    padding: '5px 15px'
};

export const searchInputStyles: SxProps<Theme> = {
    bgcolor: modalColors.black5,
    color: modalColors.white,
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        border: 'none'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: 'none'
    },
    '& input::placeholder': {
        color: 'grey.400',
        opacity: 1
    }
};

export const tabsContainerStyles: SxProps<Theme> = {
    bgcolor: modalColors.black3,
    px: 2,
    pt: 2
};

export const tabsStyles: SxProps<Theme> = {
    '& .MuiTabs-indicator': {
        bgcolor: modalColors.mainGold
    },
    '& .MuiTab-root': {
        color: 'grey.300',
        minHeight: 'auto',
        py: 1,
        px: 2,
        textTransform: 'none',
        fontSize: '0.875rem',
        '&.Mui-selected': {
            color: modalColors.mainGold
        }
    }
};

export const getBadgeStyles = (isActive: boolean): SxProps<Theme> => ({
    '& .MuiBadge-dot': {
        bgcolor: isActive ? modalColors.goldenYellow : modalColors.errorRed,
        width: 8,
        height: 8,
        top: -2,
        right: -6
    }
});

export const checkboxContainerStyles: SxProps<Theme> = {
    px: 2,
    padding: '5px 15px'
};

export const checkboxStyles: SxProps<Theme> = {
    m: 0
};

export const checkboxIconStyles: SxProps<Theme> = {
    width: 16,
    height: 16,
    border: 2,
    borderColor: modalColors.gold,
    borderRadius: 0.5,
    bgcolor: 'transparent'
};

export const checkedIconStyles: SxProps<Theme> = {
    width: 16,
    height: 16,
    border: 2,
    borderColor: modalColors.gold,
    borderRadius: 0.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

export const checkboxLabelStyles: SxProps<Theme> = {
    color: 'grey.300'
};

export const discussionsContainerStyles: SxProps<Theme> = {
    flex: 1,
    overflow: 'auto',
    px: 2,
    pt: 2,
    bgcolor: modalColors.black4
};

export const discussionCardStyles: SxProps<Theme> = {
    bgcolor: modalColors.black4,
    color: 'white'
};

export const cardContentStyles: SxProps<Theme> = {
    p: 2,
    '&:last-child': { pb: 2 }
};

export const cardHeaderStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
};

export const cardBodyStyles: SxProps<Theme> = {
    flex: 1,
    minWidth: 0
};

export const workTypeStyles: SxProps<Theme> = {
    color: modalColors.white30,
    display: 'block',
    mb: 0.5
};

export const workTitleStyles: SxProps<Theme> = {
    cursor: 'pointer',
    color: modalColors.white,
    fontWeight: 500,
    mb: 1
};

export const timestampStyles: SxProps<Theme> = {
    color: modalColors.white30
};

export const actionsContainerStyles: SxProps<Theme> = {
    ml: 2
};

export const notificationButtonStyles: SxProps<Theme> = {
    color: 'orange.500',
    p: 0.5
};

export const openButtonStyles: SxProps<Theme> = {
    color: 'grey.400',
    '&:hover': { color: 'white' },
    p: 0.5
};
